import styled from "styled-components";

export const InfoIcon = styled.span`
  cursor: pointer;
  background-color: lightgray;
  border-radius: 50%;
  margin: 0px 5px;
  height: 1.5rem;
  min-height: 1.5rem;
  width: 1.5rem;
  min-width: 1.5rem;
  aspect-ratio: 1.5;
  font-size: 0.8rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Tooltip = styled.div`
  position: absolute;
  font-family: Poppins;
  font-size: 12px;
  background-color: #00205C;
  color: #fff;
  border: 1px solid #00205C;
  border-radius: 7px;
  padding: 10px;
  width: 200px;
  z-index: 2;
  @media screen and (max-width: 479px) {
    left: 1rem;
    bottom: -1rem;
  }
`;
